import React from 'react';
import './DoctorDashboardData.scss';

const DoctorDashboardData = () => {
    return (
        <div className="doctorDashboardData w-100 SubParentDesign" >
            <div className="d-flex align-items-center justify-content-center">
                <h2 className="mt-5 pt-5" style={{color:'#050545'}}>Welcome To The Doctor Dashboard</h2>
            </div>
        </div>
    );
};

export default DoctorDashboardData;